import React from 'react';
import { FiShield, FiTool, FiGlobe, FiDollarSign, FiUsers, FiZap } from 'react-icons/fi';
import Reveal from '../fx/Reveal';
import CascadeGrid from '../fx/CascadeGrid';

const features = [
    {
        icon: <FiShield size={26} />,
        title: 'Expert Team',
        description: 'Certified practitioners with real-world incident response and red-team engagements.',
    },
    {
        icon: <FiTool size={26} />,
        title: 'Hands-on Labs',
        description: 'Lab-first pedagogy. Every concept is reinforced with a live target you can break.',
    },
    {
        icon: <FiGlobe size={26} />,
        title: 'Local Expertise',
        description: 'Content in Bahasa Indonesia, tuned to regulatory and threat landscape locally.',
    },
    {
        icon: <FiDollarSign size={26} />,
        title: 'Fair Pricing',
        description: 'Student-friendly tiers for individuals. Transparent quoting for enterprises.',
    },
    {
        icon: <FiUsers size={26} />,
        title: 'Community-Driven',
        description: 'Active community of learners, mentors, alumni, and partner CTF teams.',
    },
    {
        icon: <FiZap size={26} />,
        title: 'Fast Turnaround',
        description: 'From kickoff to first deliverable in days, not weeks. Continuous comms.',
    },
];

const WhyChoose = () => {
    return (
        <section className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto text-center">
                <Reveal>
                    <span className="pill tag inline-flex mb-4">WHY US</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold mb-3">
                        Why teams choose <span className="text-gradient-red">SiberLab ID</span>
                    </h2>
                    <p className="text-gray-400 max-w-2xl mx-auto text-lg mb-14">
                        We combine deep technical expertise, practical experience, and innovative delivery.
                    </p>
                </Reveal>

                <CascadeGrid className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" stagger={100}>
                    {features.map((feature, idx) => (
                        <div key={idx} className="card p-6 text-left h-full">
                            <div className="w-11 h-11 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400 mb-4">
                                {feature.icon}
                            </div>
                            <h3 className="font-display text-lg font-semibold mb-2">{feature.title}</h3>
                            <p className="text-gray-400 text-sm leading-relaxed">{feature.description}</p>
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default WhyChoose;
